import { Link } from "react-router-dom"

export const Slider = () => {
  return (
    <div
      id="carouselExampleIndicators"
      className="carousel slide"
      data-ride="carousel"
      data-interval="4000"
    >
      <ol className="carousel-indicators">
        <li
          type="button"
          data-target="#carouselExampleIndicators"
          data-slide-to="0"
          className="active"
          aria-current="true"
          aria-label="Slide 1"
        ></li>
        <li
          type="button"
          data-target="#carouselExampleIndicators"
          data-slide-to="1"
          aria-label="Slide 2"
        ></li>
        <li
          type="button"
          data-target="#carouselExampleIndicators"
          data-slide-to="2"
          aria-label="Slide 3"
        ></li>
        <li
          type="button"
          data-target="#carouselExampleIndicators"
          data-slide-to="3"
          aria-label="Slide 4"
        ></li>
        <li
          type="button"
          data-target="#carouselExampleIndicators"
          data-slide-to="4"
          aria-label="Slide 5"
        ></li>
        <li
          type="button"
          data-target="#carouselExampleIndicators"
          data-slide-to="5"
          aria-label="Slide 6"
        ></li>
      </ol>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <Link to="/products/type/kurtas">
            <img
              src="https://assets.myntassets.com/f_webp,w_980,c_limit,fl_progressive,dpr_2.0/assets/images/2022/5/31/1768e5bd-41a3-4373-b583-eafb68c41f401654006978408-Indian-Wear_DK.jpg"
              className="d-block w-100"
              alt="..."
            />
          </Link>
        </div>

        <div className="carousel-item">
          <Link to="/products/type/shirts">
            <img
              src="https://assets.myntassets.com/f_webp,w_980,c_limit,fl_progressive,dpr_2.0/assets/images/2022/7/25/9be788ff-39a4-4214-99d0-fc97505aae5a1658752545685-USPA_Desk_Banner.jpg"
              className="d-block w-100"
              alt="..."
            />
          </Link>
        </div>
        <div className="carousel-item">

          <Link to="/products/type/kurtas">
            <img
              src="https://assets.myntassets.com/f_webp,w_980,c_limit,fl_progressive,dpr_2.0/assets/images/2022/6/1/7b1da839-34a4-4e78-b5b5-e18af304e3bd1654099311017-Top-Kurta-Sets_Desk.jpg"
              className="d-block w-100"
              alt="..."
            />
          </Link>
        </div>
        <div className="carousel-item">
          <Link to="/products/type/tops">
            <img
              src="https://assets.myntassets.com/f_webp,w_980,c_limit,fl_progressive,dpr_2.0/assets/images/2022/7/25/b656a7f4-4688-4997-bb7c-54b78793981e1658752386588-Western-Wear_Desk.jpg"
              className="d-block w-100"
              alt="..."
            />
          </Link>
        </div>
        <div className="carousel-item">
          <Link to="/products/type/jumpsuits">
            <img
              src="https://assets.myntassets.com/f_webp,w_980,c_limit,fl_progressive,dpr_2.0/assets/images/2022/7/28/0174e4d7-448c-4746-8572-69461ad5be101659020268081-Tops---Tees_Desk.jpg"
              className="d-block w-100 "
              alt="..."
            />
          </Link>
        </div>
        <div className="carousel-item">
          <Link to="/products/type/shoes">

            <img
              src="https://assets.myntassets.com/f_webp,w_980,c_limit,fl_progressive,dpr_2.0/assets/images/2022/5/31/4031994d-9092-4aa7-aea1-f52f2ae5194f1654006594976-Activewear_DK.jpg"
              className="d-block w-100 "
              alt="..."
            />
          </Link>
        </div>

      </div>
      {/* <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button> */}
    </div>
  );
};
